/**
 * Login container.
 */
import React, {Component} from 'react';
import RequestResetPasswordMutation from '../mutations/request_reset_password_mutation';
import {emailRegEx} from '../constants';
import * as tracking from '../tracking';
import {injectIntl} from 'react-intl';
import Util from '../forecast-app/shared/util/util';

class ForgotPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorMsg: null,
			isSent: false,
			email: '',
		};
		this.props.setLocaleFromBrowser();
	}

	componentDidMount() {
		// Segment
		tracking.trackPage('forgot-password');
	}

	handleSubmit(event) {
		if (event) {
			event.preventDefault();
		}

		const email = this.state.email.trim();
		if (!email.length) {
			this.setState({errorMsg: 'Field cannot be empty'});
			return;
		}
		const regEx = new RegExp(emailRegEx);
		if (!regEx.test(email)) {
			this.setState({errorMsg: 'Invalid email format'});
			return;
		}

		var onSuccess = response => {
			if (response.requestResetPassword.success) {
				this.setState({isSent: true});
			} else {
				if (!response.requestResetPassword.errors) return;
				this.setState({errorMsg: this.props.intl.formatMessage({id: 'reset_password.' + response.requestResetPassword.errors[0]})});
			}
		};
		Util.CommitMutation(
			RequestResetPasswordMutation,
			{
				email: email,
			},
			onSuccess
		);
	}

	handleEmailChange(e) {
		this.setState({email: e.target.value});
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<div className="fullscreen fullscreen-centered-outer login first-login-bg">
				<div className="logo" />
				<div className="fullscreen-centered-inner">
					<div className="fullscreen-centered-content form-vertical">
						{this.state.isSent ? (
							<div className="fieldset">
								<h1>Thank you!</h1>
								<h3>{"Check '" + this.state.email + "' for further instructions."}</h3>
							</div>
						) : (
							<form onSubmit={this.handleSubmit.bind(this)}>
								<h1>{formatMessage({id: 'login.reset-password'})}</h1>
								<div className="fieldset">
									<input type="text" id="email" defaultValue="" placeholder={formatMessage({id: 'login.enter-email-address'})} onChange={this.handleEmailChange.bind(this)} />
									<a href="login">{formatMessage({id: 'login.remember-your-password'})}</a>
									{this.state.errorMsg ? <div className="error">{this.state.errorMsg}</div> : ''}
								</div>
								<div className="buttons">
									<input type="submit" value={formatMessage({id: 'login.reset-password'})} className={'btn btn-pull-right'} />
								</div>
							</form>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(ForgotPassword);
